define('areas/activityfeedconfigurator/service/billingemail-service',["require", "exports", "services/httpclient"], function (require, exports, HttpClient) {
    "use strict";
    var BillingService = (function () {
        function BillingService() {
        }
        BillingService.prototype.get = function (organizationId) {
            var service = new HttpClient.Channel();
            return service.getDataAsync("/activation/api/billingemail/getbillingemails/" + organizationId, HttpClient.ServiceTarget.oneClickServiceApi)
                .then(function (data) {
                return data;
            })
                .fail(function (error) {
                console.log(error);
                return error;
            });
        };
        BillingService.prototype.post = function (organizationId, data) {
            var service = new HttpClient.Channel();
            return service.postDataAsync("/activation/api/billingemail/postbillingemails/" + organizationId, HttpClient.ServiceTarget.oneClickServiceApi, data);
        };
        return BillingService;
    }());
    exports.BillingService = BillingService;
});

